import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CustomModal from '@utilities/CustomModal';
import { APP_LABELS, CDP } from '@config/app-config';
import BasePage from '@BasePage';
import { VALID_EMAIL_TOKEN, SAVE_PLEDGE_PAGE_DATA } from '@config/api-config';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';
import YMCALogo from '../../static/images/ymca-logo-light.svg';
import user21 from '../../static/images/user-21.svg';
import exclamationicon from '../../static/images/exclamation.png';

const PledgeStatement = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [userExpiredErrorMessage, setUserExpiredErrorMessage] = useState('');
  const [userExpired, setUserExpired] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);
  const [acknowledgeBoardAndBylaw, setAcknowledgeBoardAndBylaw] =
    useState(false);
  const [acknowledgeTrademarkLicense, setAcknowledgeTrademarkLicense] =
    useState(false);
  const [name, setName] = useState('');
  const [signatureName, setSignatureName] = useState('');
  const [selectedDate, setSelectedDate] = useState();
  const [disabledSave, setDisabledSave] = useState(true);
  const [jobTitle, setJobTitle] = useState('');
  const [validationMessage, setValidationMessage] = useState(false);
  const pledgeInstruction = `<p><strong>Instructions</strong></p><ol style="list-style-type:decimal;"><li><span style="color:hsl(0,0%,0%);"><strong>Pledge your Commitment: </strong>The CEO and the chief volunteer officer (CVO) affirm their commitment to upholding the statement of purpose and membership criteria established by the </span><a target="_blank" rel="noopener noreferrer" href="https://link.ymca.net/mlink/file/MjE4ODY"><span style="color:hsl(0,0%,0%);">Constitution and Bylaws of the National Council of Young Men’s Christian Associations of the United States of America </span></a><span style="color:hsl(0,0%,0%);">(YMCA National Constitution).</span></li><li><span style="color:hsl(0,0%,0%);"><strong>Sign the Pledge Statement: </strong>The CEO and the CVO indicate acceptance of the statement of purpose and membership criteria. For the 2023 certification year, CEOs and CVOs enter their name preceded and followed by forward slashes(e.g.,/JohnDoe/) for the required electronic signature at the bottom of the Pledge Statement.</span></li><li><span style="color:hsl(0,0%,0%);"><strong>Do Not Delegate: </strong>Unlike other sections of the annual report, the CEO may not delegate the Pledge Statement to a staff member for completion.</span></li><li><span style="color:hsl(0,0%,0%);"><strong>Review the key questions for the CEO section: </strong>This section includes checkboxes that the CEO can choose to mark.&nbsp;</span></li></ol>`;
  const subpledgeInstruction1 = `<p><span style="color:#00AEEF;"><strong>Annual Certification Pledge Statement for the CEO</strong></span></p><p style="margin-left:0px;">Please affirm the pledge statement. You must accept the terms by initialing and signing below before submitting.</p><p style="margin-left:0px;">The National Council of Young Men Christian Associations of the United States of America, in Article II, Section 2, of its constitution, requires annual certification by member associations on these specific points. We,&nbsp;the undersigned, in applying for a listing in the official roster of duly organized Young Men\'s Christian Associations, certify the following:</p>`;
  const subpledgeInstruction2 = `<p style=\"margin-left:0px;\">a. That our association accepts and supports the statement of purpose of the Young Men's Christian Associations of the United States of America,&nbsp;which is: The Young Men's Christian Association we regard as being in its essential genius a worldwide fellowship united by a common loyalty to&nbsp;Jesus Christ for the purpose of developing Christian personality and building a Christian society.&nbsp;<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://link.ymca.net/mlink/file/MjYyMTY?type=attachment\"><span style=\"color:#00AEEF;\"><u>Learn more.</u></span></a></p><p style=\"margin-left:0px;\">b. That our governing documents provide that it shall be designated as a Young Men's Christian Association and which is organized and operated in conformity with this Constitution.</p><p style=\"margin-left:0px;\">c. That our association accepts the constitution of the National Council of YMCAs of the&nbsp;United States of America.</p><p style=\"margin-left:0px;\">d. That our association pays monthly to the National Council one-twelfth, of its share of the fair share support of the National Council by electronic fund transfer,&nbsp;or such other means as directed by the National Council;&nbsp;Provided that in exceptional circumstances a member association may be released from this requirement in whole or in part and on conditions by the action of the National Board</p><p style=\"margin-left:0px;\">e. That our association will annually report to the National Board concerning such matters as the Board may request from time to time.</p><p style=\"margin-left:0px;\">f. That our association chief employed officer meets the education and&nbsp;training qualifications of that position as determined by the National Board.</p><p style=\"margin-left:0px;\">g. That our association will annually certify that it does not unlawfully discriminate against its staff, board, volunteers, committees, or recipients&nbsp;of services based on any characteristic or status protected by federal, state, or local law and is committed to a culture of inclusion, and understands, respects and values the diversity of others.&nbsp;<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://link.ymca.net/mlink/site_page/NDEw\"><span style=\"color:#00AEEF;\"><u>Learn more.</u></span></a></p><p style=\"margin-left:0px;\">h. That our association is recognized by the Internal Revenue Service as an exempt organization described in Section 501(c) (3) of the Internal Revenue Code of 1986 as amended&nbsp;or any successor provision thereto and conforms to applicable federal. state or local laws regulating charitable nonprofit or not-for-profit corporations.</p><p style=\"margin-left:0px;\">i. That our association will annually acknowledge that it shall use the legal name&nbsp;\"Young Men's Christian Association\" and all names, marks, logos, symbols, and other intellectual property as authorized by the National Council; that such intellectual property is the property of the National Council, and that as a member association we have a limited, revocable, non-exclusive and non-transferable right and duty to use the such intellectual property only as permitted by the National Board through its policies and guidelines to protect the YMCA brand and reputation.</p><p style=\"margin-left:0px;\">j. That our association will annually certify that, notwithstanding its autonomy, it recognizes its responsibility&nbsp;as part of a national movement; it shall not act in a manner which the National Board, Through its National Committee on Membership Standards, determines adversely impacts the reputation of other member associations, the YMCA brand or the national movement.</p><p style=\"margin-left:0px;\">k. That our association will annually certify that&nbsp;notwithstanding its local autonomy, it shall meet child abuse prevention and aquatic safety practices specified by the National Board.</p>`;
  const subpledgeInstruction22025 = `<p style=\"margin-left:0px;\">a. That our association accepts and supports the statement of purpose of the Young Men's Christian Associations of the United States of America,&nbsp;which is: The Young Men's Christian Association we regard as being in its essential genius a worldwide fellowship united by a common loyalty to&nbsp;Jesus Christ for the purpose of developing Christian personality and building a Christian society.&nbsp;<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://link.ymca.net/mlink/file/MjYyMTY?type=attachment\"><span style=\"color:#00AEEF;\"><u>Learn more.</u></span></a></p><p style=\"margin-left:0px;\">b. That our governing documents provide that it shall be designated as a Young Men's Christian Association and which is organized and operated in conformity with this Constitution.</p><p style=\"margin-left:0px;\">c. That our association accepts the constitution of the National Council of YMCAs of the&nbsp;United States of America.</p><p style=\"margin-left:0px;\">d. That our association pays monthly to the National Council one-twelfth, of its share of the fair share support of the National Council by electronic fund transfer,&nbsp;or such other means as directed by the National Council;&nbsp;Provided that in exceptional circumstances a member association may be released from this requirement in whole or in part and on conditions by the action of the National Board</p><p style=\"margin-left:0px;\">e. That our association will annually report to the National Board concerning such matters as the Board may request from time to time.</p><p style=\"margin-left:0px;\">f. That our association chief employed officer meets the education and&nbsp;training qualifications of that position as determined by the National Board.</p><p style=\"margin-left:0px;\">g. That our association will annually certify that it does not unlawfully discriminate against its staff, board, volunteers, committees, or recipients&nbsp;of services based on any characteristic or status protected by federal, state, or local law.</p><p style=\"margin-left:0px;\">h. That our association is recognized by the Internal Revenue Service as an exempt organization described in Section 501(c) (3) of the Internal Revenue Code of 1986 as amended&nbsp;or any successor provision thereto and conforms to applicable federal. state or local laws regulating charitable nonprofit or not-for-profit corporations.</p><p style=\"margin-left:0px;\">i. That our association will annually acknowledge that it shall use the legal name&nbsp;\"Young Men's Christian Association\" and all names, marks, logos, symbols, and other intellectual property as authorized by the National Council; that such intellectual property is the property of the National Council, and that as a member association we have a limited, revocable, non-exclusive and non-transferable right and duty to use the such intellectual property only as permitted by the National Board through its policies and guidelines to protect the YMCA brand and reputation.</p><p style=\"margin-left:0px;\">j. That our association will annually certify that, notwithstanding its autonomy, it recognizes its responsibility&nbsp;as part of a national movement; it shall not act in a manner which the National Board, Through its National Committee on Membership Standards, determines adversely impacts the reputation of other member associations, the YMCA brand or the national movement.</p><p style=\"margin-left:0px;\">k. That our association will annually certify that&nbsp;notwithstanding its local autonomy, it shall meet child abuse prevention and aquatic safety practices specified by the National Board.</p>`;
  const subpledgeInstruction3 = `<p><span style="color:#00AEEF;"><strong>Board and Bylaw Statement for the CEO and CVO/Board Chair</strong></span></p>`;
  const subpledgeInstruction4 = `<p style=\"margin-left:0px;\">a. The member association's Board annually reviews its Bylaws.</p><p style=\"margin-left:0px;\">b. The Bylaws follow state and local guidelines.</p><p style=\"margin-left:0px;\">c. The Board's policies and procedures are inclusive of language included on the IRS Form 990, Part VI, Section B—conflict of interest, whistleblower, document retention and destruction.</p>`;
  const subInstructions5Title = `<p><span style="color:#00AEEF;"><strong>Trademark License Statement for CEO and CVO/Board Chair</strong></span></p>`;
  const subInstructions5 = `<p style=\"margin-left:0px;\"><strong>1. License Grant:</strong> Subject to the terms and conditions herein, YMCA of the USA (“Licensor”) hereby grants to you/Member Association (“Licensee”) a non-exclusive, non-transferable license to use YMCA, U.S. Reg. No. 668,795, The Y YMCA Logo, U.S. Reg. No. 3,917,712 and other U.S. federally protected trademarks owned by Licensor (collectively “YUSA Trademarks”) solely in connection with programs and services provided within its service area.&nbsp;</p><p style=\"margin-left:0px;\"><strong>2. Ownership:</strong> The Licensee acknowledges that the Licensor is the sole and exclusive owner of YUSA Trademarks as governed by Article VIII of the National Council of Young Men’s Christian Associations of the United States of America’s Constitution and Bylaws. The Licensee shall not contest or challenge the Licensor's ownership of YUSA Trademarks or take any action inconsistent with such ownership. Should Licensee cease to operate as a Member Association it, including all volunteers, officers, directors, agents, and employees agree to cease use of YUSA Trademarks and remove all YUSA Trademarks in accordance with the guidelines outlined in the NCMS Manual.</p><p style=\"margin-left:0px;\"><strong>3. Use/Markings:</strong> The Licensee shall use YUSA Trademarks strictly in accordance with the standards and guidelines provided by the Licensor as outlined in Licensor’s NCMS Manual, Sublicense Agreement Program, and Brand Resource Guidelines (collectively “YUSA Trademark Guidelines”) within its service area(s).</p><p style=\"margin-left:0px;\">The Licensee shall display YUSA Trademarks in the form and manner directed and approved by the Licensor. The Licensee shall include any legends, markings, or notices (e.g., YMCA®) required by the Licensor to indicate the trademark rights of the Licensor.</p><p style=\"margin-left:0px;\"><strong>4. Quality Control:</strong> The Licensee shall permit the Licensor to inspect its use of YUSA Trademarks to ensure compliance with the quality standards as outlined in YUSA’s Trademark Guidelines. Any deviations from these standards must be corrected promptly upon notice from the Licensor.</p><p style=\"margin-left:0px;\"><strong>5. Derivatives/Trademark Protection:</strong> The Licensee agrees that it will not (a) create a trademark and/or (b) seek trademark protection for derivatives of the YUSA Trademarks, including terms with the singular letter “Y” inferring it’s an acronym for or associated with a YMCA.</p><p style=\"margin-left:0px;\"><strong>6. Sublicense Grant:</strong> Subject to the Licensee entering YUSA’s Sublicense Agreement Program, the Licensee may grant a limited, non-exclusive, non-transferable sublicense to use YUSA Trademarks to third parties solely in connection with programs and services provided within its service area. Each sublicense shall be in writing and in accordance with YUSA’s Sublicense Agreement Program.</p><p style=\"margin-left:0px;\">Licensee acknowledges and agrees that it is not permitted to sublicense YUSA trademarks to third parties (i.e., sports teams, media, nationwide/global brands, etc.) outside its service area indicating a nationwide relationship. All such requests must be reviewed and approved by YUSA. If the third-party is to be granted a license, it will be entered into and granted by YUSA.</p><p style=\"margin-left:0px;\"><strong>7. Term:</strong> The license granted herein shall commence on the Effective Date of the Annual Report and must be acknowledged and agreed to annually by Licensee, unless terminated earlier by the Licensor.</p>`;
  const [
    ceoYActivelyParticipatesStateAllianceValidationMessage,
    setCeoYActivelyParticipatesStateAllianceValidationMessage
  ] = useState('');
  const [
    ceoYStrategicPlanValidationMessage,
    setCeoYStrategicPlanValidationMessage
  ] = useState('');
  const [associationName, setAssociationName] = useState('');
  const [
    ceoYActivelyParticipatesStateAlliance,
    setCeoYActivelyParticipatesStateAlliance
  ] = useState('');
  const [ceoYStrategicPlan, setCeoYStrategicPlan] = useState('');

  const [
    boardReviewsBylawsEveryThreeYears,
    setBoardReviewsBylawsEveryThreeYears
  ] = useState('');
  const [
    boardPlansToReviewBylawsNextYear,
    setBoardPlansToReviewBylawsNextYear
  ] = useState('');
  const [
    bylawsFollowStateLocalGuidelines,
    setBylawsFollowStateLocalGuidelines
  ] = useState('');
  const [
    boardPoliciesIncludeIRSRequirements,
    setBoardPoliciesIncludeIRSRequirements
  ] = useState('');

  const [
    boardReviewsBylawsEveryThreeYearsValidationMessage,
    setBoardReviewsBylawsEveryThreeYearsValidationMessage
  ] = useState('');
  const [
    boardPlansToReviewBylawsNextYearValidationMessage,
    setBoardPlansToReviewBylawsNextYearValidationMessage
  ] = useState('');
  const [
    bylawsFollowStateLocalGuidelinesValidationMessage,
    setBylawsFollowStateLocalGuidelinesValidationMessage
  ] = useState('');
  const [
    boardPoliciesIncludeIRSRequirementsValidationMessage,
    setBoardPoliciesIncludeIRSRequirementsValidationMessage
  ] = useState('');

  const [showMessage, setShowMessage] = useState({
    status: '',
    type: '',
    message: '',
    isOpen: false
  });
  const [errorMessage, setErrorMessage] = useState(false);
  const handleCeoYStrategicPlan = event => {
    setCeoYStrategicPlan(event.target.value);
    setCeoYStrategicPlanValidationMessage('');
  };

  const handleboardReviewsBylawsEveryThreeYears = event => {
    setBoardReviewsBylawsEveryThreeYears(event.target.value);
    setBoardReviewsBylawsEveryThreeYearsValidationMessage('');
  };

  const handleBoardPlansToReviewBylawsNextYear = event => {
    setBoardPlansToReviewBylawsNextYear(event.target.value);
    setBoardPlansToReviewBylawsNextYearValidationMessage('');
  };

  const handleBylawsFollowStateLocalGuidelines = event => {
    setBylawsFollowStateLocalGuidelines(event.target.value);
    setBylawsFollowStateLocalGuidelinesValidationMessage('');
  };

  const handleBoardPoliciesIncludeIRSRequirements = event => {
    setBoardPoliciesIncludeIRSRequirements(event.target.value);
    setBoardPoliciesIncludeIRSRequirementsValidationMessage('');
  };

  const handleCeoYActivelyParticipatesStateAlliance = event => {
    setCeoYActivelyParticipatesStateAlliance(event.target.value);
    setCeoYActivelyParticipatesStateAllianceValidationMessage('');
  };

  const handleAcknowledgmentChange = event => {
    setAcknowledged(event.target.checked);
  };
  const handleAcknowledgmentBoardandByLawChange = event => {
    setAcknowledgeBoardAndBylaw(event.target.checked);
  };
  const handleAcknowledgeTrademarkLicense = event => {
    setAcknowledgeTrademarkLicense(event.target.checked);
  };
  const handleNameChange = event => {
    setSignatureName(event.target.value.trimStart());
    setSelectedDate(new Date());
  };

  const handleDateChange = event => {
    setSelectedDate(event.target.value);
  };

  let tokenValue;
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('token')) {
    tokenValue = urlParams.get('token');
  }

  const handleTokenValidation = () => {
    setUserExpired(false);
    setUserExpiredErrorMessage('');
    axios
      .get(`${VALID_EMAIL_TOKEN()}${tokenValue}`)
      .then(response => {
        setAssociationName(response?.data?.data?.associationName);
        // Handle successful response
        if (response?.data?.isSuccess) {
          if (
            response?.data?.pledge?.recordStatus?.toUpperCase() !==
            APP_LABELS.STATUS_SUBMITTED
          ) {
            setDisabledSave(false);
          }
          if (response?.data?.pledge?.jobTitle === 'CEO') {
            if (
              response?.data?.pledge?.ceoYActivelyParticipatesStateAlliance ===
                null ||
              response?.data?.pledge?.ceoYStrategicPlan === null ||
              response?.data?.pledge?.acknowledge === false ||
              response?.data?.pledge?.acknowledge === null ||
              response?.data?.pledge?.signatureName === null ||
              response?.data?.pledge?.dateSigned === null ||
              (response?.data?.data?.year >= '2024' &&
                (response?.data?.pledge?.acknowledgeBoardAndBylaw === null ||
                  response?.data?.pledge?.acknowledgeBoardAndBylaw ===
                    false)) ||
              (response?.data?.data?.year >= '2025' &&
                (response?.data?.pledge?.ceoAcknowledgeTrademarkLicense ===
                  null ||
                  response?.data?.pledge?.ceoAcknowledgeTrademarkLicense ===
                    false))
            ) {
              setDisabledSave(false);
            }
          }

          if (response?.data?.pledge?.jobTitle === 'CVO') {
            if (
              response?.data?.pledge?.acknowledge === false ||
              response?.data?.pledge?.acknowledge === null ||
              response?.data?.pledge?.signatureName === null ||
              response?.data?.pledge?.dateSigned === null ||
              (response?.data?.data?.year >= '2024' &&
                (response?.data?.pledge?.acknowledgeBoardAndBylaw === null ||
                  response?.data?.pledge?.acknowledgeBoardAndBylaw ===
                    false)) ||
              (response?.data?.data?.year >= '2025' &&
                (response?.data?.pledge?.cvoAcknowledgeTrademarkLicense ===
                  null ||
                  response?.data?.pledge?.cvoAcknowledgeTrademarkLicense ===
                    false))
            ) {
              setDisabledSave(false);
            }
          }

          if (response?.data?.data?.year >= '2025') {
            setBoardReviewsBylawsEveryThreeYears(
              `${response?.data?.pledge?.boardReviewsBylawsEveryThreeYears}`
            );
            if (
              response?.data?.pledge?.boardReviewsBylawsEveryThreeYears ===
              false
            ) {
              setBoardPlansToReviewBylawsNextYear(
                `${response?.data?.pledge?.boardPlansToReviewBylawsNextYear}`
              );
            }
            setBylawsFollowStateLocalGuidelines(
              `${response?.data?.pledge?.bylawsFollowStateLocalGuidelines}`
            );
            setBoardPoliciesIncludeIRSRequirements(
              `${response?.data?.pledge?.boardPoliciesIncludeIRSRequirements}`
            );
            if (response?.data?.pledge?.jobTitle?.toUpperCase() === 'CEO') {
              setAcknowledgeTrademarkLicense(
                response?.data?.pledge?.ceoAcknowledgeTrademarkLicense
              );
            }
            if (response?.data?.pledge?.jobTitle?.toUpperCase() === 'CVO') {
              setAcknowledgeTrademarkLicense(
                response?.data?.pledge?.cvoAcknowledgeTrademarkLicense
              );
            }
          }

          setData(response?.data);
          sessionStorage.setItem(
            'pledgeassociationname',
            response?.data?.data?.associationName || ''
          );
          setCeoYActivelyParticipatesStateAlliance(
            `${response?.data?.pledge?.ceoYActivelyParticipatesStateAlliance}`
          );
          setCeoYStrategicPlan(`${response?.data?.pledge?.ceoYStrategicPlan}`);
          setAcknowledged(response?.data?.pledge?.acknowledge);
          if (response?.data?.data?.year >= '2024') {
            setAcknowledgeBoardAndBylaw(
              response?.data?.pledge?.acknowledgeBoardAndBylaw
            );
          }
          setSignatureName(
            response?.data?.pledge?.signatureName
              ? response?.data?.pledge?.signatureName
              : response?.data?.pledge?.name
          );
          setName(response?.data?.pledge?.name);
          setSelectedDate(
            response?.data?.pledge?.dateSigned
              ? response?.data?.pledge?.dateSigned
              : new Date()
          );
          setJobTitle(response?.data?.pledge?.jobTitle);
        } else {
          setUserExpired(true);
          setUserExpiredErrorMessage(response?.data?.message);
        }

        setLoader(false);
      })
      .catch(err => {
        // Handle error
        setErrorMessage(err.message);
        setErrorPopup(true);
        setLoader(false);
      });
  };

  useEffect(() => {
    setLoader(true);

    document.querySelectorAll('.ymca-menubar').forEach(el => {
      el.setAttribute('style', 'display:none !important');
    });

    handleTokenValidation();
  }, []);

  const handleSubmit = async e => {
    setLoader(true);
    setValidationMessage(false);
    setCeoYStrategicPlanValidationMessage('');
    setCeoYActivelyParticipatesStateAllianceValidationMessage('');
    setBoardReviewsBylawsEveryThreeYearsValidationMessage('');
    setBylawsFollowStateLocalGuidelinesValidationMessage('');
    setBoardPlansToReviewBylawsNextYearValidationMessage('');
    setBoardPoliciesIncludeIRSRequirementsValidationMessage('');
    e.preventDefault();
    let IsValid = true;
    if (data?.data?.year >= '2025') {
      if (
        !boardReviewsBylawsEveryThreeYears ||
        boardReviewsBylawsEveryThreeYears === null ||
        boardReviewsBylawsEveryThreeYears === 'null'
      ) {
        setBoardReviewsBylawsEveryThreeYearsValidationMessage(
          '* Please select one option.'
        );
        window.scroll(0, 900);
        setLoader(false);
        return;
      }

      if (boardReviewsBylawsEveryThreeYears === 'false') {
        if (
          !boardPlansToReviewBylawsNextYear ||
          boardPlansToReviewBylawsNextYear === null ||
          boardPlansToReviewBylawsNextYear === 'null'
        ) {
          setBoardPlansToReviewBylawsNextYearValidationMessage(
            '* Please select one option.'
          );
          window.scroll(0, 900);
          setLoader(false);
          return;
        }
      }

      if (
        !bylawsFollowStateLocalGuidelines ||
        bylawsFollowStateLocalGuidelines === null ||
        bylawsFollowStateLocalGuidelines === 'null'
      ) {
        setBylawsFollowStateLocalGuidelinesValidationMessage(
          '* Please select one option.'
        );
        window.scroll(0, 900);
        setLoader(false);
        return;
      }

      if (
        !boardPoliciesIncludeIRSRequirements ||
        boardPoliciesIncludeIRSRequirements === null ||
        boardPoliciesIncludeIRSRequirements === 'null'
      ) {
        setBoardPoliciesIncludeIRSRequirementsValidationMessage(
          '* Please select one option.'
        );
        window.scroll(0, 900);
        setLoader(false);
        return;
      }
    }

    if (jobTitle === 'CEO') {
      if (
        !ceoYStrategicPlan ||
        ceoYStrategicPlan === null ||
        ceoYStrategicPlan === 'null'
      ) {
        setCeoYStrategicPlanValidationMessage('* Please select one option.');
        IsValid = false;
        window.scroll(0, 900);
        setLoader(false);
      }

      if (
        !ceoYActivelyParticipatesStateAlliance ||
        ceoYActivelyParticipatesStateAlliance === null ||
        ceoYActivelyParticipatesStateAlliance === 'null'
      ) {
        setCeoYActivelyParticipatesStateAllianceValidationMessage(
          '* Please select one option.'
        );
        IsValid = false;
        setLoader(false);
      }

      if (
        acknowledged === false ||
        acknowledged === null ||
        signatureName === null ||
        signatureName === '' ||
        selectedDate === null ||
        (data?.data?.year >= '2024' &&
          (acknowledgeBoardAndBylaw === null ||
            acknowledgeBoardAndBylaw === false)) ||
        (data?.data?.year >= '2025' &&
          (acknowledgeTrademarkLicense === null ||
            acknowledgeTrademarkLicense === false))
      ) {
        setValidationMessage(true);
        IsValid = false;
        setLoader(false);
      }
      if (!IsValid) {
        return;
      }
    }

    if (jobTitle === 'CVO') {
      if (
        acknowledged === false ||
        acknowledged === null ||
        signatureName === null ||
        signatureName === '' ||
        selectedDate === null ||
        (data?.data?.year >= '2024' &&
          (acknowledgeBoardAndBylaw === null ||
            acknowledgeBoardAndBylaw === false)) ||
        (data?.data?.year >= '2025' &&
          (acknowledgeTrademarkLicense === null ||
            acknowledgeTrademarkLicense === false))
      ) {
        setValidationMessage(true);
        setLoader(false);
        return;
      }
    }

    let payload = {
      acknowledge: acknowledged,
      associationNumber: data?.data?.associationNumber,
      ceoYActivelyParticipatesStateAlliance:
        ceoYActivelyParticipatesStateAlliance === 'true',
      ceoYStrategicPlan: ceoYStrategicPlan === 'true',
      dateSigned: selectedDate,
      jobTitle: data?.pledge?.jobTitle,
      signatureName,
      name,
      token: tokenValue,
      year: data?.data?.year,
      personId: data?.data?.personId,
      staffId: data?.data?.staffId
    };

    if (data?.data?.year >= '2024') {
      payload = {
        ...payload,
        acknowledgeBoardAndBylaw: acknowledgeBoardAndBylaw
      };

      if (data?.data?.year >= '2025') {
        payload = {
          ...payload,
          boardReviewsBylawsEveryThreeYears:
            boardReviewsBylawsEveryThreeYears === 'true',
          bylawsFollowStateLocalGuidelines:
            bylawsFollowStateLocalGuidelines === 'true',
          boardPoliciesIncludeIRSRequirements:
            boardPoliciesIncludeIRSRequirements === 'true',
          boardPlansToReviewBylawsNextYear:
            boardPlansToReviewBylawsNextYear === 'true'
        };
      }

      if (jobTitle === 'CEO' && data?.data?.year >= '2025') {
        payload = {
          ...payload,
          ceoAcknowledgeTrademarkLicense: acknowledgeTrademarkLicense
        };
      }

      if (jobTitle === 'CVO' && data?.data?.year >= '2025') {
        payload = {
          ...payload,
          cvoAcknowledgeTrademarkLicense: acknowledgeTrademarkLicense
        };
      }
    }

    const headers = {
      Authorization: tokenValue
    };
    try {
      const response = await axios.post(SAVE_PLEDGE_PAGE_DATA(), payload, {
        headers
      });
      setShowMessage({
        status: APP_LABELS.SUCCESS,
        type: APP_LABELS.SUCCESS,
        message: CDP.MESSAGES.pledgeSuccessMessage,
        isOpen: true
      });

      setLoader(false);
    } catch (err) {
      setErrorMessage(err.response.data.message || err.message);
      setErrorPopup(true);
      setLoader(false);
    }
  };
  const successOkay = () => {
    setShowMessage({ isOpen: false });
    window.location.reload();
  };

  return (
    <BlockUi
      blocking={loader}
      message="Loading, please wait"
      loader={<Loader active type="semi-circle-spin" />}
    >
      <BasePage includeHeader includeFooter={false}>
        <div
          className={`${
            data?.pledge?.recordStatus?.toUpperCase() ===
            APP_LABELS.STATUS_SUBMITTED
              ? 'disable-input-role no-cursor'
              : ''
          }  pledge-statement-page`}
        >
          <div className="pledge-menubar">
            <div className="navbar d-block">
              <Link className="navbar-brand offset-1" to="/home">
                <img src={YMCALogo} alt="ymca-logo" />
              </Link>
              <span className="ymca-association-name notranslate ms-4 ">
                {associationName}
              </span>
            </div>
          </div>
          {userExpired && userExpiredErrorMessage !== '' ? (
            <div className="container pt-4">
              <div className="row my-5 pt-5 justify-content-center">
                <div className="col-10">
                  <div className="card ymca-primary-card d-flex align-items-center justify-content-center h-100 mt-2">
                    <h3 className="ymca-error-head">
                      {'Hello User,'}
                      <br />
                      <br />
                      {userExpiredErrorMessage}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="container pt-4">
              <div className="ymca-headingTitle mt-5 mb-4  pt-60">
                <strong>Pledge Statement</strong>
              </div>
              <div className="ymca-program">
                <div className="ymca-covidRelif px-0">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2 pb-2">
                    {data?.pledge?.recordStatus?.toUpperCase() ===
                      APP_LABELS.STATUS_SUBMITTED && (
                      <div className="YMCCA-tostAlert overflow-hidden pb-3 mb-3">
                        <div className="YMCCA-textList">
                          <img src={exclamationicon} alt="exclamation" />
                          <span>
                            Your pledge statement has already been submitted.
                            Below is a read only copy.
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="ymca-instructionBoxes">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pledgeInstruction
                        }}
                      />
                    </div>
                  </div>

                  <form className="ymca-form">
                    {data?.pledge?.jobTitle === 'CEO' && (
                      <>
                        <h4 className="ymca-headingTitle">
                          Key Questions for the CEO
                        </h4>

                        <h4 className="ymca-textTitle txt-mandatory my-0">
                          The YMCA currently has a strategic plan guiding the
                          organization that has been adopted by the board within
                          the last three years.
                        </h4>
                        <div className="ymca-radioBTN d-flex p-1">
                          <div className="ymca-setListing me-4">
                            <input
                              type="radio"
                              className="ymca-fieldRadio"
                              name="ceoYstrategicPlan"
                              value="true"
                              checked={ceoYStrategicPlan === 'true'}
                              onChange={handleCeoYStrategicPlan}
                            />
                            <span className="ymca-texting">Yes</span>
                          </div>
                          <div className="ymca-setListing me-4">
                            <input
                              type="radio"
                              className="ymca-fieldRadio"
                              name="ceoYstrategicPlan"
                              value="false"
                              checked={ceoYStrategicPlan === 'false'}
                              onChange={handleCeoYStrategicPlan}
                            />
                            <span className="ymca-texting">No</span>
                          </div>
                        </div>
                        {ceoYStrategicPlanValidationMessage && (
                          <div>
                            <span className="errorNote">
                              {ceoYStrategicPlanValidationMessage}
                            </span>
                          </div>
                        )}
                        <div className="mt-4">
                          <h4 className="ymca-textTitle txt-mandatory my-0">
                            The YMCA actively participates in its State Alliance
                            as defined by attending at least one gathering
                            annually, actively supporting alliance priorities,
                            and paying dues timely and in full.
                          </h4>
                        </div>
                        <div className="ymca-radioBTN d-flex p-1">
                          <div className="ymca-setListing me-4">
                            <input
                              type="radio"
                              name="ceoYactivelyParticipatesStateAlliance"
                              value="true"
                              className="ymca-fieldRadio"
                              checked={
                                ceoYActivelyParticipatesStateAlliance === 'true'
                              }
                              onChange={
                                handleCeoYActivelyParticipatesStateAlliance
                              }
                            />
                            <span className="ymca-texting">Yes</span>
                          </div>
                          <div className="ymca-setListing  me-4">
                            <input
                              type="radio"
                              name="ceoYactivelyParticipatesStateAlliance"
                              value="false"
                              className="ymca-fieldRadio"
                              checked={
                                ceoYActivelyParticipatesStateAlliance ===
                                'false'
                              }
                              onChange={
                                handleCeoYActivelyParticipatesStateAlliance
                              }
                            />
                            <span className="ymca-texting">No</span>
                          </div>
                        </div>
                        {ceoYActivelyParticipatesStateAllianceValidationMessage && (
                          <div>
                            <span className=" errorNote">
                              {
                                ceoYActivelyParticipatesStateAllianceValidationMessage
                              }
                            </span>
                          </div>
                        )}
                      </>
                    )}

                    <hr className="mt-4" />
                    <div
                      className="ymca-textTitle"
                      dangerouslySetInnerHTML={{
                        __html: subpledgeInstruction1
                      }}
                    />
                    <div className="ymca-pointsTable ymca-scrollableText">
                      <div
                        className="ymca-textTitle toast-body"
                        dangerouslySetInnerHTML={{
                          __html:
                            data?.data?.year >= '2025'
                              ? subpledgeInstruction22025
                              : subpledgeInstruction2
                        }}
                      />
                    </div>
                    {data?.data?.year === '2024' && (
                      <>
                        <div
                          className="ymca-textTitle mt-3"
                          dangerouslySetInnerHTML={{
                            __html: subpledgeInstruction3
                          }}
                        />
                        <div className="ymca-pointsTable ymca-scrollableText">
                          <div
                            className="ymca-textTitle toast-body"
                            dangerouslySetInnerHTML={{
                              __html: subpledgeInstruction4
                            }}
                          />
                        </div>
                      </>
                    )}
                    {data?.data?.year >= '2025' && (
                      <>
                        <div
                          className="ymca-textTitle mt-3"
                          dangerouslySetInnerHTML={{
                            __html: subpledgeInstruction3
                          }}
                        />
                        {/* <div className="ymca-pointsTable ymca-scrollableText">
                           <div
                            className="ymca-textTitle toast-body"
                            dangerouslySetInnerHTML={{
                              __html: subpledgeInstruction4
                            }}
                          /> 
                        </div> */}
                        <>
                          <div className="mt-4">
                            <h4 className="ymca-textTitle txt-mandatory my-0">
                              a. The member association’s Board has reviewed its
                              Bylaws in the last three years.
                            </h4>
                          </div>
                          <div className="ymca-radioBTN d-flex p-1">
                            <div className="ymca-setListing me-4">
                              <input
                                type="radio"
                                name="boardReviewsBylawsEveryThreeYears"
                                value="true"
                                className="ymca-fieldRadio"
                                onChange={
                                  handleboardReviewsBylawsEveryThreeYears
                                }
                                checked={
                                  boardReviewsBylawsEveryThreeYears === 'true'
                                }
                              />
                              <span className="ymca-texting">Yes</span>
                            </div>
                            <div className="ymca-setListing">
                              <input
                                type="radio"
                                name="boardReviewsBylawsEveryThreeYears"
                                value="false"
                                className="ymca-fieldRadio"
                                onChange={
                                  handleboardReviewsBylawsEveryThreeYears
                                }
                                checked={
                                  boardReviewsBylawsEveryThreeYears === 'false'
                                }
                              />
                              <span className="ymca-texting">No</span>
                            </div>
                          </div>
                          {boardReviewsBylawsEveryThreeYearsValidationMessage && (
                            <div className="errorNote">
                              {
                                boardReviewsBylawsEveryThreeYearsValidationMessage
                              }
                            </div>
                          )}
                          {boardReviewsBylawsEveryThreeYears === 'false' && (
                            <>
                              <div className="mt-4">
                                <ul>
                                  <li>
                                    <h4 className="ymca-textTitle txt-mandatory my-0">
                                      The member association’s board has not
                                      reviewed its bylaws but intends to within
                                      this calendar year.
                                    </h4>
                                  </li>
                                </ul>
                              </div>
                              <div className="ymca-radioBTN d-flex p-1">
                                <div className="ymca-setListing ms-4 me-4">
                                  <input
                                    type="radio"
                                    name="boardPlansToReviewBylawsNextYear"
                                    value="true"
                                    className="ymca-fieldRadio"
                                    onChange={
                                      handleBoardPlansToReviewBylawsNextYear
                                    }
                                    checked={
                                      boardPlansToReviewBylawsNextYear ===
                                      'true'
                                    }
                                  />
                                  <span className="ymca-texting">Yes</span>
                                </div>
                                <div className="ymca-setListing">
                                  <input
                                    type="radio"
                                    name="boardPlansToReviewBylawsNextYear"
                                    value="false"
                                    className="ymca-fieldRadio"
                                    onChange={
                                      handleBoardPlansToReviewBylawsNextYear
                                    }
                                    checked={
                                      boardPlansToReviewBylawsNextYear ===
                                      'false'
                                    }
                                  />
                                  <span className="ymca-texting">No</span>
                                </div>
                              </div>
                              {boardPlansToReviewBylawsNextYearValidationMessage && (
                                <div className="errorNote">
                                  {
                                    boardPlansToReviewBylawsNextYearValidationMessage
                                  }
                                </div>
                              )}
                            </>
                          )}

                          <div className="mt-4">
                            <h4 className="ymca-textTitle txt-mandatory my-0">
                              b. The Bylaws follow state and local guidelines.
                            </h4>
                          </div>
                          <div className="ymca-radioBTN d-flex p-1">
                            <div className="ymca-setListing me-4">
                              <input
                                type="radio"
                                name="bylawsFollowStateLocalGuidelines"
                                value="true"
                                className="ymca-fieldRadio"
                                onChange={
                                  handleBylawsFollowStateLocalGuidelines
                                }
                                checked={
                                  bylawsFollowStateLocalGuidelines === 'true'
                                }
                              />
                              <span className="ymca-texting">Yes</span>
                            </div>
                            <div className="ymca-setListing">
                              <input
                                type="radio"
                                name="bylawsFollowStateLocalGuidelines"
                                value="false"
                                className="ymca-fieldRadio"
                                onChange={
                                  handleBylawsFollowStateLocalGuidelines
                                }
                                checked={
                                  bylawsFollowStateLocalGuidelines === 'false'
                                }
                              />
                              <span className="ymca-texting">No</span>
                            </div>
                          </div>
                          {bylawsFollowStateLocalGuidelinesValidationMessage && (
                            <div className="errorNote">
                              {
                                bylawsFollowStateLocalGuidelinesValidationMessage
                              }
                            </div>
                          )}
                          <div className="mt-4">
                            <h4 className="ymca-textTitle txt-mandatory my-0">
                              c. The Board's policies and procedures are
                              inclusive of language included on the IRS Form
                              990, Part VI, Section B—conflict of interest,
                              whistleblower, document retention and destruction.
                            </h4>
                          </div>
                          <div className="ymca-radioBTN d-flex p-1">
                            <div className="ymca-setListing me-4">
                              <input
                                type="radio"
                                name="boardPoliciesIncludeIRSRequirements"
                                value="true"
                                className="ymca-fieldRadio"
                                onChange={
                                  handleBoardPoliciesIncludeIRSRequirements
                                }
                                checked={
                                  boardPoliciesIncludeIRSRequirements === 'true'
                                }
                              />
                              <span className="ymca-texting">Yes</span>
                            </div>
                            <div className="ymca-setListing">
                              <input
                                type="radio"
                                name="boardPoliciesIncludeIRSRequirements"
                                value="false"
                                className="ymca-fieldRadio"
                                onChange={
                                  handleBoardPoliciesIncludeIRSRequirements
                                }
                                checked={
                                  boardPoliciesIncludeIRSRequirements ===
                                  'false'
                                }
                              />
                              <span className="ymca-texting">No</span>
                            </div>
                          </div>
                          {boardPoliciesIncludeIRSRequirementsValidationMessage && (
                            <div className="errorNote">
                              {
                                boardPoliciesIncludeIRSRequirementsValidationMessage
                              }
                            </div>
                          )}
                          <div
                            className="ymca-textTitle mt-3"
                            dangerouslySetInnerHTML={{
                              __html: subInstructions5Title
                            }}
                          />
                          <div className="ymca-pointsTable ymca-scrollableText">
                            <div
                              className="ymca-textTitle toast-body"
                              dangerouslySetInnerHTML={{
                                __html: subInstructions5
                              }}
                            />
                          </div>
                        </>
                      </>
                    )}
                    <div className="row">
                      <div className="col-xl-6 col-lg-6">
                        <div className="ymca-pointsTable p-0 mt-4 mb-4">
                          <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                              <div className="d-flex">
                                <img
                                  src={user21}
                                  alt="user21"
                                  className="me-3"
                                />
                                <h4 className="ymca-headingTitle">
                                  {data?.pledge?.name} <br />
                                  {data?.pledge?.jobTitle === 'CVO'
                                    ? 'Chief Volunteer Officer/Board Chair '
                                    : data?.pledge?.jobTitle}
                                </h4>
                              </div>

                              <p className="ymca-textTitle txt-mandatory mb-1">
                                <input
                                  type="checkbox"
                                  className="styled-checkbox me-2"
                                  checked={acknowledged}
                                  onChange={handleAcknowledgmentChange}
                                />
                                I acknowledge the pledge statement
                              </p>
                              {data?.data?.year >= '2024' && (
                                <p className="ymca-textTitle txt-mandatory">
                                  <input
                                    type="checkbox"
                                    className="styled-checkbox me-2"
                                    checked={acknowledgeBoardAndBylaw}
                                    onChange={
                                      handleAcknowledgmentBoardandByLawChange
                                    }
                                  />
                                  I acknowledge the board and bylaw statements
                                </p>
                              )}
                              {data?.data?.year >= '2025' && (
                                <>
                                  <p className="ymca-textTitle txt-mandatory">
                                    <input
                                      type="checkbox"
                                      className="styled-checkbox me-2"
                                      checked={acknowledgeTrademarkLicense}
                                      onChange={
                                        handleAcknowledgeTrademarkLicense
                                      }
                                    />
                                    I acknowledge the Trademark License
                                    statements
                                  </p>
                                </>
                              )}
                            </div>

                            <div className="col-xl-6 col-lg-6 col-md-4 col-sm-12 col-12">
                              <div className="ymca-selectWrap">
                                <div
                                  className={`ymca-labelling txt-mandatory ${
                                    data?.pledge?.jobTitle === 'CVO'
                                      ? 'annual-report-pledge-cvo'
                                      : ''
                                  }`}
                                >
                                  Signature Name of{' '}
                                  {data?.pledge?.jobTitle === 'CVO'
                                    ? 'Chief Volunteer Officer/Board Chair '
                                    : data?.pledge?.jobTitle}
                                </div>
                                <input
                                  type="text"
                                  className="ymca-fieldSet"
                                  value={signatureName}
                                  onChange={handleNameChange}
                                />
                              </div>
                            </div>

                            <div className="col-xl-6 col-lg-6 col-md-4 col-sm-12 col-12">
                              <div className="ymca-selectWrap">
                                <div
                                  className={`ymca-labelling txt-mandatory ${
                                    data?.pledge?.jobTitle === 'CVO'
                                      ? 'annual-report-pledge-cvo'
                                      : ''
                                  } `}
                                >
                                  Date Signed
                                </div>
                                <input
                                  type="date"
                                  className="ymca-fieldSet"
                                  onChange={handleDateChange}
                                  value={moment(selectedDate).format(
                                    'YYYY-MM-DD'
                                  )}
                                  min={moment(
                                    new Date('1/1/1901 12:00:00')
                                  ).format('YYYY-MM-DD')}
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 ">
                              {validationMessage && (
                                <div>
                                  <span className="errorNote">
                                    * All fields are required.
                                  </span>
                                </div>
                              )}
                              <div className="ymca-selectWrap">
                                <button
                                  type="submit"
                                  className="btn ymca-savingBTN"
                                  onClick={handleSubmit}
                                  disabled={disabledSave}
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {showMessage?.isOpen && (
                    <CustomModal
                      show={showMessage.status}
                      type={showMessage.type}
                      message={showMessage.message}
                      submitButtonName="Okay"
                      onSubmit={successOkay}
                    />
                  )}
                  <ErrorPopup
                    handleCloseErrorPopup={() => {
                      setErrorPopup(false);
                    }}
                    errorMessage={errorMessage}
                    showErrorPopup={errorPopup}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </BasePage>
    </BlockUi>
  );
};
export default PledgeStatement;
